import { join } from 'light-component';
import { Block, Box } from '@common';
import * as Base from '@base';
import { Highlighter } from '../../component';
import { service } from '../service';
import styles from '../style.module.less';
import type { ReactElement } from 'react';
import type { TextAreaProps } from './types';

export function TextAreaInputMode(props: TextAreaProps): ReactElement {
  return (
    <Box className={styles.inputBox} style={{ marginLeft: service.getIndent(props.path, 0.7) }}>
      <Box className={styles.subject}>
        <Block if={props.number != null}>{props.number}、</Block>
        <Block if={props.typeName != null}>
          <Base.Tag color='#ff943f'>{props.typeName}</Base.Tag>
        </Block>
        <Highlighter
          title={props.title}
          require={props.validator === 'required'}
          keyword={props.keyword}
          className={styles.title}
        />
      </Box>
      <Box className={join(styles.action, styles.input)}>
        <Base.Input.TextArea
          value={props.value}
          placeholder={props.textPlaceholder}
          readOnly={props.readonly === true}
          onChange={event => props.onPropsChange?.({ value: event.target.value })}
        />
      </Box>
    </Box>
  );
}
